// Mixin to render status color on status text across the system
import { VIEW_FORM_STATUS, get_headers, get_project_id } from '@/utils/constants/constants.js';
import axios from 'axios';

export const statusMixin = {
  data: () => ({
    global_status_colors: {},
    is_status_colors_loaded: false,
  }),
  
  methods: {
    async fetch_global_status_colors() {
      // If already loaded, return immediately
      if (this.is_status_colors_loaded && Object.keys(this.global_status_colors).length > 0) {
        return this.global_status_colors;
      }

      const payload = { project_id: get_project_id() };

      return axios.get(VIEW_FORM_STATUS, {
        headers: get_headers(),
        params: payload
      })
      .then(response => {
        // Create a global mapping of status names to colors
        this.global_status_colors = {};
        response.data.data.forEach((status) => {
          const status_name = status.status.replace(/_/g, ' ');
          Reflect.set(this.global_status_colors, status_name, status.color_code || status.color);
        });

        this.is_status_colors_loaded = true;
        return this.global_status_colors;
      })
      .catch(() => {
        // Return empty object if request fails
        return {};
      });
    },

    get_status_color(status_name) {
      if (!status_name) {
        return;
      }
      
      // Try to find exact match first (safe access)
      let color = Reflect.get(this.global_status_colors, status_name);

      // If not found, try case-insensitive match
      if (!color) {
        const normalized_status = status_name.toLowerCase();
        const found_key = Object.keys(this.global_status_colors).find(
          key => key.toLowerCase() === normalized_status
        );

        // Securely access only if the key truly exists on the object
        if (found_key && Object.hasOwn(this.global_status_colors, found_key)) {
          color = Reflect.get(this.global_status_colors, found_key);
        } else {
          color = '#000000';
        }
      }
      
      return color;
    },

    // Method to ensure status colors are loaded
    async ensure_status_colors_loaded() {
      if (!this.is_status_colors_loaded) {
        await this.fetch_global_status_colors();
      }
    }
  },

  // Auto-fetch status colors when component is created
  async created() {
    await this.ensure_status_colors_loaded();
  }
}